export const SharedConstants = {
    regexPatternEmail: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
    inputFormatDate: 'dd/MM/yyyy',
    inputFormatDatedMy: 'dd/MM/yyyy',
    inputFormatDatedMyHm: 'dd/MM/yyyy HH:mm',
    inputFormatDateyMd: 'yyyy-MM-dd',
    outputFormatDate: 'dd/MM/yyyy',
    outputFormatDatedMy: 'dd/MM/yyyy',
    outputMomentFormatDate: 'DD MMM YYYY',
    outputFormatDateDMMMY: 'DD MMM YYYY',
    momentFormatDate: 'YYYY-MM-DD',
    UPDATE_BACK_BUTTON_EVENT: 'UPDATE_BACK_BUTTON'
};
